module.exports = __webpack_public_path__ + "img/toggle-off.cb113b05.svg";